import Peer from 'skyway-js'

const createPeer = () => {
  const peer = new Peer({
    key: process.env.VUE_APP_API_KEY,
    debug: process.env.VUE_APP_DEBUG_LEVEL
  })

  return peer
}

export default createPeer
